import { render, staticRenderFns } from "./ArrowIcon.vue?vue&type=template&id=16784913&scoped=true&"
import script from "./ArrowIcon.vue?vue&type=script&lang=js&"
export * from "./ArrowIcon.vue?vue&type=script&lang=js&"
import style0 from "./ArrowIcon.vue?vue&type=style&index=0&id=16784913&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16784913",
  null
  
)

export default component.exports